import { cn } from "@omni/utils/styles";
import React, { PropsWithChildren } from "react";

import { Col, ColumnProps } from "@/components/General/Grid/col.component";

export type ResultFieldProps = PropsWithChildren<{
    copy: string;
    copyPostfix?: string | React.ReactNode;
    value: any;
    unit?: string;
    sup?: number;
    sm?: ColumnProps;
    md?: ColumnProps;
    lg?: ColumnProps;
    className?: string;
}>;

const ResultField = ({
    copy,
    copyPostfix,
    value,
    unit,
    sup,
    sm,
    md,
    lg,
    className,
    children
}: ResultFieldProps) => {
    return (
        <Col
            sm={sm}
            md={md}
            lg={lg}
            className={cn(
                "tw:flex tw:max-sm:group-[:not(:first-child)]:ml-3.75 tw:mb-4",
                className
            )}
        >
            <div className={cn("tw:inline-block")}>
                {children}
                {copy}
                {copyPostfix && (
                    <div className={cn("tw:text-sm")}>{copyPostfix}</div>
                )}
            </div>
            <div className={cn("tw:flex tw:ml-auto tw:pl-1")}>
                {value.toString().replace(".", ",")}
                <div className={cn("tw:w-8 tw:ml-2")}>
                    {unit}
                    {unit && sup && <sup>{sup}</sup>}
                </div>
            </div>
        </Col>
    );
};

export default ResultField;
